var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.83266 3.64H7.14266V2.48H5.83266V3.64ZM5.88266 10H7.09266V4.52H5.88266V10Z",
  fill: "#FA4F38"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 6.5,
  r: 6,
  stroke: "#FA4F38"
})));
export default SvgInfoLight;